import { addDays } from 'date-fns';
import { useSecondRecurringSessionCalendar } from 'domains/calendars/signup/useSecondRecurringSessionCalendar';
import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { getFilteringAreasByConcernKeys } from 'domains/signupDirect/misc/communicationConcerns';
import { useSplitEvaluationCtx } from '../SplitEvaluationsScheduleSection';
import { EvaluationDuration } from 'domains/calendars/types';

export const useSignupSecondSplitCalendarData = () => {
  const { firstTimeSlot } = useSplitEvaluationCtx();
  const { filters } = useSignupDirectCtx();

  if (!firstTimeSlot) throw new Error('Expected first time slot to be set');
  if (!filters) throw new Error('Expected filters to be set');

  const { paymentMethod, stateCode } = filters;

  const isInsuranceAndInNetwork =
    paymentMethod.type === 'insurance' && paymentMethod.insuranceData.networkStatus === 'In-network';

  const fromDate = addDays(firstTimeSlot.time, 1);

  return useSecondRecurringSessionCalendar({
    firstSession: firstTimeSlot.time,
    fromDate,
    toDate: addDays(fromDate, 7),

    detectedAreas: getFilteringAreasByConcernKeys(filters.clinicalConcernKeys, filters.therapyTarget),
    insuranceName: isInsuranceAndInNetwork ? paymentMethod.insuranceData.insuranceName : undefined,
    state: stateCode,
    duration: EvaluationDuration.Split,
  });
};
